;(function () {

"use strict";

var FormView = require('../views/form');

var PermissionsFormView = FormView.extend({
  save: function (e) {
    console.log('saving');
    FormView.prototype.save.call(this, e);

    var data = this.$el.find('input[name!=permissions]').serializeArray();

    var permissions = [];
    this.$el.find('input[name=permissions]').each(function () {
      var checked = $(this).is(':checked');
      if (checked) {
        permissions.push($(this).val());
      }
    });

    if (permissions.length === 0) {
      return ShopifyApp.flashNotice("Permissions cannot be blank.");      
    }

    data.push({ name: 'scope', value: permissions });

    ShopifyApp.Bar.loadingOn();
    $.post('/permissions', data, _.bind(this.onSave, this));
  },
  onSave: function (data) {
    console.log(data);
    console.log('save completed');

    ShopifyApp.Bar.loadingOff();

    if (data.status === 'success') {
      ShopifyApp.flashNotice(data.msg);
    } else if (data.status === 'redirect') {
      window.location.href = data.url;
    } else {
      ShopifyApp.Modal.alert({
        title: 'Saving Settings Failed',
        message: data.err
      });
    }
  }
});

var PageView = Backbone.View.extend({
  initialize: function () {
    console.log('permissions page view init');
    new PermissionsFormView({el: this.$el.find('form').first() });
  }
});

module.exports = PageView;


}());